import { User } from 'Browser/User';
import { ArtistsConfig } from 'Common/artists/ArtistsConfig';
import { BuildBasics } from 'Common/BuildBasics';
import { SiteBasics } from 'Common/SiteBasics';
import { Urls } from 'Common/Urls';
import { IVenueConfig } from 'Shared/config/IVenueConfig';
import { ConnectionToServer, IRootProps } from 'Shared/Root';
import {createContext,useContext} from 'solid-js';

interface ISiteProviderProps extends IRootProps {
	children;
	user: () => User;
	setUser: (user:User) => void;
	venueConfig: ArtistsConfig|IVenueConfig
;
}

const SiteContext = createContext();

export function SiteProvider(props:ISiteProviderProps)
{
	return (
		<SiteContext.Provider value={props}>
			{props.children}
		</SiteContext.Provider>
	);
}

export function useBuild():BuildBasics
{
	return (useContext(SiteContext) as ISiteProviderProps).build;
}

export function useSite():SiteBasics
{
	return (useContext(SiteContext) as ISiteProviderProps).site;
}

export function useUser():/*resolved signal*/User
{
	return (useContext(SiteContext) as ISiteProviderProps).user();
}

export function useServer():ConnectionToServer
{
	return (useContext(SiteContext) as ISiteProviderProps).server;
}

export function useVenueConfig()
{
	return (useContext(SiteContext) as ISiteProviderProps).venueConfig;
}

export function useUrls()
{
	const context = useContext(SiteContext) as ISiteProviderProps;
	return new Urls(context.build,context.site);
}


